import { render, staticRenderFns } from "./VaRatingItem.vue?vue&type=template&id=0c8d7620&"
import script from "./VaRatingItem.vue?vue&type=script&lang=js&"
export * from "./VaRatingItem.vue?vue&type=script&lang=js&"
import style0 from "./VaRatingItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports